import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const BASE_PATH = 'simulation/bridal-item'

const client = new ApiClient(API_NAME)

export default {
  updateSimulationTarget(businessId, data) {
    return client.put(`/business/${businessId}/${BASE_PATH}`, data)
  },
  updateCollageTarget(businessId, data) {
    return client.put(`/business/${businessId}/bridal-item/collage`, data)
  },

  /**
   * 最新の見積シミュレーションを取得する
   * @param {number} businessId 案件ID
   * @returns {Promise<any>} レスポンス
   */
  getLatest(businessId) {
    const query = {}
    query.latest_flag = 'true'
    return client.get(`/business/${businessId}/${BASE_PATH}`, query)
  },

  /**
   * 履歴の見積シミュレーションを取得する
   * @param {number} businessId 案件ID
   * @param {number} simulationHistoryId シミュレーション履歴ID
   * @returns {Promise<any>} レスポンス
   */
  getHistory(businessId, simulationHistoryId) {
    const query = {}
    query.latest_flag = 'false'
    query.simulation_history_id = simulationHistoryId
    return client.get(`/business/${businessId}/${BASE_PATH}`, query)
  },

  /**
   * 見積シミュレーションを一括更新する
   * @param {number} businessId 案件ID
   * @param {object} data 見積シミュレーションデータ
   * @returns {Promise<any>} レスポンス
   */
  update(businessId, data) {
    const url = `/business/${businessId}/${BASE_PATH}/bulk`
    return client.put(url, data)
  }
}
